import { render, staticRenderFns } from "./SearchSummaryBarLinkMatches.vue?vue&type=template&id=44910a39"
import script from "./SearchSummaryBarLinkMatches.vue?vue&type=script&lang=ts"
export * from "./SearchSummaryBarLinkMatches.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PuCampsiteAvailabilityLink: require('/app/apps/pu-links/link-campsite/PuCampsiteAvailabilityLink.vue').default,PuSearchWizardLink: require('/app/apps/pu-links/link-search-wizard/PuSearchWizardLink.vue').default})
